import styled from "styled-components";

export const HomeDiv = styled.div`
  height: 12%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  @media (min-width: 740px) {
    width: 60%;
    justify-content: space-between;
  }
`;
export const HomeDiv2 = styled.div`
  height: 15%;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-around;
  @media (min-width: 740px) {
    width: 60%;
    align-items: flex-start;
  }
`;

export const HomeDiv3 = styled.div`
  height: 70%;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-around;
`;
export const HomeDiv4 = styled.div`
  height: 10%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  @media (min-width: 740px) {
    width: 60%;
    justify-content: space-between;
  }
`;
export const HomeDiv5 = styled.div`
  border-radius: 15px;
  height: 87%;
  width: 95%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-around;
  background-color: #212529;
  @media (min-width: 740px) {
    width: 60%;
  }
`;
